/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesList } from "../../funcs/imagesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListImageMetadataRequest$inboundSchema,
};

export const tool$imagesList: ToolDefinition<typeof args> = {
  name: "images-list",
  description: `List metadata for all images in the specified account.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
